import { CircularProgress, Logo } from '@cere/cere-design-system';

export type BootstrapStage = 'verifying' | 'initializing';

interface Props {
  stage: BootstrapStage;
}

/**
 * Splash shown while the page is auto-reconnecting the user's stored Cere
 * wallet session (`stage="verifying"`) or loading their vault record after
 * the wallet is back (`stage="initializing"`). Uses the same `vault-claim`
 * chrome as the connect prompt so the swap is seamless once we know
 * whether the user needs to take action.
 */
export function VaultBootstrapping({ stage }: Props) {
  const { title, sub } = stage === 'verifying'
    ? { title: 'Verifying wallet', sub: 'Checking your Cere wallet session…' }
    : { title: 'Initializing your Vault', sub: 'Loading your saved Vault…' };
  return (
    <div className="vault-claim">
      <div className="vault-claim__halo vault-claim__halo--tl" aria-hidden />
      <div className="vault-claim__halo vault-claim__halo--br" aria-hidden />
      <div className="vault-claim__card vault-claim__card--bootstrapping">
        <div className="vault-claim__logo"><Logo size="large" /></div>
        <h1 className="vault-claim__title">{title}</h1>
        <p className="vault-claim__sub">{sub}</p>
        <div className="vault-claim__bootstrap-progress">
          <CircularProgress size={24} />
        </div>
      </div>
    </div>
  );
}
